import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'
import { CLEAR_PROJECT_DETAILS } from '../ProjectSettings/constants'
import { sortObjectsByName } from '../../utils/sortManager'

import roles from './roles.json'

const initialState = fromJS({
  sort: 'Name',
  sortDirection: 'ASC',
  contactSort: 'Name',
  contactSortDirection: 'ASC',
  projectContacts: []
}).set('roles', roles)

function teamManagementUsersReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PROJECTS_TEAM:
      return state
        .set('gettingProjectTeam', true)
        .delete('projectTeam', true)
        .delete('getProjectTeamError', true)
    case actionTypes.GET_PROJECTS_TEAM_DONE:
      return state
        .set('projectTeam', fromJS(action.team))
        .set('gettingProjectTeam', false)
    case actionTypes.GET_PROJECTS_TEAM_ERROR:
      return state
        .set('getProjectTeamError', action.error)
        .set('gettingProjectTeam', false)

    case actionTypes.GET_PROJECT_CONTACTS:
      return state
        .set('gettingProjectContacts', true)
        .delete('getProjectContactsError')
    case actionTypes.GET_PROJECT_CONTACTS_DONE:
      return state
        .set('projectContacts', fromJS(action.contacts))
        .set('gettingProjectContacts', false)
    case actionTypes.GET_PROJECT_CONTACTS_ERROR:
      return state
        .set('getProjectContactsError', action.error)
        .set('gettingProjectContacts', false)
    case actionTypes.CLEAR_CONTACT_LIST:
      return state
        .set('gettingProjectContacts', false)
        .delete('projectContacts')
        .delete('getProjectContactsError')

    case actionTypes.GET_CONTACT_BY_ID:
      return state
        .set('gettingContactById', true)
        .delete('contact')
        .delete('getContactByIdError')
    case actionTypes.GET_CONTACT_BY_ID_DONE:
      return state
        .set('contact', action.contact)
        .set('gettingContactById', false)
    case actionTypes.GET_CONTACT_BY_ID_ERROR:
      return state
        .set('getContactByIdError', action.error)
        .set('gettingContactById', false)

    case actionTypes.UPDATE_CONTACT:
      return state
        .set('updatingContact', true)
        .delete('updatedContact')
        .delete('updateContactError')
    case actionTypes.UPDATE_CONTACT_DONE:
      return state
        .set('updatedContact', action.contact)
        .set('updatingContact', false)
    case actionTypes.UPDATE_CONTACT_ERROR:
      return state
        .set('updateContactError', action.error)
        .set('updatingContact', false)

    case actionTypes.DELETE_CONTACT:
      return state
        .set('deletingContact', true)
        .delete('getProjectContactsError')
    case actionTypes.DELETE_CONTACT_DONE:
      return state.set('deletingContact', false)
    case actionTypes.DELETE_CONTACT_ERROR:
      return state
        .set('getProjectContactsError', action.error)
        .set('deletingContact', false)

    case actionTypes.INVITE_CONTACT_TO_MEMBERS:
      return state.set('invitingContactToMembers', true)
    case actionTypes.INVITE_CONTACT_TO_MEMBERS_DONE:
      return state.set('invitingContactToMembers', false)
    case actionTypes.INVITE_CONTACT_TO_MEMBERS_ERROR:
      return state.set('inviteContactToMembersError', action.error)

    case actionTypes.ADD_NEW_MEMBERS_ERROR:
      return state.set('addNewMembersError', action.error)

    case actionTypes.UPDATE_MEMBER:
      return state.set('updatingMember', true).delete('updateMemberError')
    case actionTypes.UPDATE_MEMBER_DONE:
      return state.set('updatingMember', false)
    case actionTypes.UPDATE_MEMBER_ERROR:
      return state
        .set('updateMemberError', action.error)
        .set('updatingMember', false)

    case actionTypes.REMOVE_MEMBERS:
      return state.set('removingMembers', true)
    case actionTypes.REMOVE_MEMBERS_DONE:
      return state.set('removingMembers', false)
    case actionTypes.REMOVE_MEMBERS_ERROR:
      return state
        .set('removeMembersError', action.error)
        .set('removingMembers', false)

    case actionTypes.IMPORT_CONTACTS_DONE: {
      return state.set(
        'projectContacts',
        fromJS(
          state
            .get('projectContacts')
            .push(...action.importedContacts)
            .toJS()
            .sort(sortObjectsByName)
        )
      )
    }
    case actionTypes.CHANGE_SORT: {
      let newSortDirection = 'ASC'
      const sort = state.get('sort')
      const sortDirection = state.get('sortDirection')

      if (sort === action.sort && sortDirection === 'ASC') {
        newSortDirection = 'DESC'
      }
      return state
        .set('sort', action.sort)
        .set('sortDirection', newSortDirection)
    }
    case actionTypes.CHANGE_CONTACT_SORT: {
      let newSortDirection = 'ASC'
      const sort = state.get('contactSort')
      const sortDirection = state.get('contactSortDirection')

      if (sort === action.sort && sortDirection === 'ASC') {
        newSortDirection = 'DESC'
      }
      return state
        .set('contactSort', action.sort)
        .set('contactSortDirection', newSortDirection)
    }

    case CLEAR_PROJECT_DETAILS:
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default teamManagementUsersReducer
